module.exports = __webpack_public_path__ + "static/img/coins.66442eb7.png";